import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { mapPublisherToMonoPublisher, shouldShowBoostChat } from '../../util/chats';
import { isProd } from '../../util/check-environment';
import { useConfigValue } from '../../hooks/useConfigValue';
import { resolveName } from '../../util/resolveName';
import lazy from '../../util/lazyLoading';

const Chats = ({ displayName, familyName, givenName, email, loginInitialized }) => {
    const config = useConfigValue();
    const { name: brandName } = config;

    const showBoostChat = shouldShowBoostChat(brandName);

    if (!showBoostChat) {
        return null;
    }

    let ChatComponent = () => null;
    let chatProps = {};

    if (showBoostChat) {
        ChatComponent = lazy(() => import('./BoostChatIntermediate'));
        const resolvedName = resolveName({
            givenName,
            familyName,
            displayName,
        });

        chatProps = {
            clientShortHandName: mapPublisherToMonoPublisher(brandName),
            isProduction: isProd(),
            user: {
                name: resolvedName,
                email,
            },
        };
    }

    return loginInitialized
        ? (
            <Suspense fallback={ null }>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <ChatComponent { ...chatProps } />
            </Suspense>
        )
        : null;
};

Chats.propTypes = {
    displayName: PropTypes.string,
    familyName: PropTypes.string,
    givenName: PropTypes.string,
    email: PropTypes.string,
    loginInitialized: PropTypes.bool.isRequired,
};

export default Chats;
